import { schema } from 'normalizr';

const employee = new schema.Entity('employees');

export default employee;

